import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import CredlyBadge from "../components/common/CredlyBadge";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/certifications.css";

const Certifications = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const currentSEO = SEO.find((item) => item.page === "certifications") || {
        description: "Industry certifications and badges.",
        keywords: ["certifications", "badges"],
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Certifications | ${INFO.main.title}`}</title>
                <meta name="description" content={currentSEO.description} />
                <meta name="keywords" content={currentSEO.keywords.join(", ")} />
            </Helmet>

            <div className="page-content">
                <NavBar active="certifications" />
                <div className="content-wrapper">
                    <div className="about-logo-container">
                        <div className="about-logo">
                            <Logo width={46} />
                        </div>
                    </div>

                    <div className="certifications-container">
                        <div className="certifications-header">
                            <div className="certifications-title">Professional Certifications</div>
                            <div className="certifications-subtitle">
                                Verified credentials showcasing expertise in cloud computing, software development, and problem-solving
                            </div>
                        </div>

                        <div className="certifications-badges-section">
                            <div className="certifications-badges-title">Industry Verified Badges</div>
                            <div className="certifications-badges">
                                <div className="badge-wrapper">
                                    <CredlyBadge shareBadgeId="aa848900-9cae-489e-ab62-1d5683a98709" iframeWidth={200} iframeHeight={270} />
                                </div>
                                <div className="badge-wrapper">
                                    <CredlyBadge shareBadgeId="aa4839d9-c429-4b02-991b-d1cac7b9ffc8" iframeWidth={200} iframeHeight={270} />
                                </div>
                                <div className="badge-wrapper">
                                    <CredlyBadge shareBadgeId="b0c72e7c-30f8-4191-8ec2-ed558c15295e" iframeWidth={200} iframeHeight={270} />
                                </div>
                            </div>
                        </div>

                        <div className="certifications-links-section">
                            <div className="certifications-links-title">Additional Certifications</div>
                            <div className="certifications-grid">
                                <div className="certification-card">
                                    <div className="cert-provider">Udemy</div>
                                    <h3>Ultimate AWS Certified Solutions Architect Associate</h3>
                                    <p>Comprehensive certification covering AWS cloud services, architecture patterns, and best practices for building scalable solutions.</p>
                                    <a href="https://www.udemy.com/certificate/UC-f124ed0f-0b8b-474a-bb5f-4410ea484005/" target="_blank" rel="noreferrer" className="cert-link">
                                        View Certificate →
                                    </a>
                                </div>
                                
                                <div className="certification-card">
                                    <div className="cert-provider">HackerRank</div>
                                    <h3>Node.js (Intermediate)</h3>
                                    <p>Understand the concepts behind an Event-Driven Architecture and Concurrency</p>
                                    <a href="https://www.hackerrank.com/certificates/7e9b7deb5b25" target="_blank" rel="noreferrer" className="cert-link">
                                        View Certificate →
                                    </a>
                                </div>
                                
                                <div className="certification-card">
                                    <div className="cert-provider">HackerRank</div>
                                    <h3>SQL (Advanced)</h3>
                                    <p>It covers topics like query optimization, data modeling, Indexing, window functions, and pivots in SQL.</p>
                                    <a href="https://www.hackerrank.com/certificates/bec228322094" target="_blank" rel="noreferrer" className="cert-link">
                                        View Certificate →
                                    </a>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>

                    <div className="page-footer">
                        <Footer />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Certifications;
